///////////////////////////////////////////////////

import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function persistLiveTabContentEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { updateTabContent } = tabsApiConnector(httpClient, 'secondaryMarketQuotes');

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_TAB_CONTENT_PERSISTENCE_REQUESTED'),
      filter(({ workspace }) => workspace === 'secondaryMarketQuotes'),
      mergeMap(({ tabId, tabContent }) => {
        return updateTabContent(tabId, tabContent).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(() => liveInputFormActions.tabContentPersisted(tabId, 'secondaryMarketQuotes')),
          catchError(() => EMPTY),
        );
      }),
    );
  };
}
